import Api from './Api';
import { DiagnosticData } from '../models/diagnostics';
import { IApiError } from '../contexts/ErrorContext';

export class DiagnosticsApi {
  static getDiagnostics(): Promise<DiagnosticData[] | IApiError> {
    return Api.GET('/diagnostics')
      .then((response) => {
        return response as DiagnosticData[];
      })
      .catch((reason) => {
        console.error('DiagnosticsApi.getDiagnostics ', reason);
        const error: IApiError = {
          error: true,
          message: 'Failed to load diagnostics',
          timestamp: new Date().getMilliseconds(),
          statusCode: 999,
        };
        return error;
      });
  }
}
